"use strict"
import { getMapIdFromName } from "../shared/utils"

export default function routes($stateProvider) {
  "ngInject"

  $stateProvider.state("mainmap", {
    url: "/map/:mapid",
    component: "mainmap",
    resolve: {
      campsitedata: (dataService, $stateParams) => {
        // return { data: { obj: 1 } }
        return dataService.getData(getMapIdFromName($stateParams.mapid))
      },
    },
    //authenticate: "admin",
  })
}
